import React, {useState} from 'react';
import {AuthFlowModal} from '@/components/blocks/AuthentificationFlow/parts/AuthFlowModal';
import { useIsMobile } from '@/data/hooks/useIsMobile';
import {AuthFlowDrawer} from '@/components/blocks/AuthentificationFlow/parts/AuthFlowDrawer';

export enum AuthFlowAction {
	LOGIN = 'login',
	REGISTER = 'register',
}

type AuthentificationDrawerProps = {
	open: boolean;
	onClose: () => void;
	type?: 'login' | 'wishlist';
}

export const AuthentificationFlow: React.FC<AuthentificationDrawerProps>= ({ open, onClose, type }) => {
	const [action, setAction] = useState<AuthFlowAction>(AuthFlowAction.LOGIN);
	const isMobil = useIsMobile();

	const handleOnClose = () => {
		setAction(AuthFlowAction.LOGIN);
		onClose();
	};

	if (!open) return null;

	return isMobil ? (
		<AuthFlowDrawer action={action} open={open} onClose={handleOnClose} onGo={setAction} />
	) : (
		<AuthFlowModal action={action} onClose={handleOnClose} onGo={setAction} type={type}/>
	);
};
